import { createContext } from "react";
import type { GroupsContextType } from "../GroupsProvider.types";

const GroupsContext = createContext<GroupsContextType | undefined>(undefined);
GroupsContext.displayName = "GroupsContext";

export default GroupsContext;
